import React from 'react'
import { Provider, connect } from 'react-redux'
import AdLibraryHolder from './styles/adLibraryViewStyle'
import adLibraryStore from '../features/adLibrary/redux/store'
import AdLibraryContainer from '../features/adLibrary/containers/AdLibraryContainer'

// The feature owns an isolated Redux store, mounted here via its own <Provider>
// (nested inside the global app Provider but overriding it for this subtree).
//
// This component is connected to the GLOBAL store (the connect HOC sits above
// the nested Provider) only to bridge the logged-in user's id down into the
// isolated store — getClients(userId) needs it and the isolated store has no
// auth state of its own.
const AdLibraryView = ({ user }) => (
  <Provider store={adLibraryStore}>
    <AdLibraryHolder>
      <AdLibraryContainer
        userId={user && user.id}
        companyId={user && user.company && user.company.id}
        companyType={user && user.company && user.company.type}
      />
    </AdLibraryHolder>
  </Provider>
)

const mapStateToProps = ({ userAccount }) => ({
  user: userAccount.user,
})

export default connect(mapStateToProps)(AdLibraryView)
